import $ from 'jquery';

export function alterDirector(form, estabelecimentoId) {
  const args = $(form).serialize();

  Promise.resolve($.post("/admin/estabelecimento/diretor", args))
    .then(resp => sisSetAlert("true", "Diretor atualizado"))
    .catch(err => sisSetAlert("false", "Ocorreu um erro ao atualizar diretor"));
}


// WEBPACK FOOTER //
// ./resources/js/diretor/form.js